const Resources = {

    table_headers: [
        { 
            text:   'Assignment #',
            value:  'number_assigment',
            type:   'link',
        },
        { 
            text:   'Description',
            align:  'start',
            value:  'description',
            type:   'link',
        },
        { 
            text: 'Days/Week',   
            value: 'days_per_week'
        },
        {   
            text: 'Avg. Time',
            value: 'avg_time_day'
        },
        {   
            text: 'Census',
            value: 'census',
            type: 'boolean'
        },
        { 
            text: 'Shift',
            value: 'shift'
        },
        { 
            text: 'Associate',
            value: 'associate'
        },
        { 
            text: 'Supervisor',
            value: 'supervisor'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Mass Edit Daily Assignments',
            href:   '/assignment-mass-edit',
            arrow:  "",
        },
    ],


}

export default Resources;